export default __webpack_public_path__ + "static/media/3334 spice rack D side.903e0b05.png";